import { observable, action, runInAction, computed} from 'mobx'
import { message } from 'antd'
import uuid from 'uuid/v4'
import { json, get } from '../../../../utils/ajax'
import {setStore} from "../../../../utils/Utils";

class ApprovalStore {

    @observable loading
    @observable carseries
    @observable directory
    @observable carSysId
    @observable forms
    @observable reviews
    @observable conceal
    @observable option
    @observable box
    @observable editFields
    @observable modal
    @observable list
    @observable pagination
    @observable contents
    @observable data
    @observable rowData

    constructor () {
        this.loading = false
        this.carseries = []
        this.directory = []
        this.option = []
        this.list = []
        this.carSysId = ''
        this.reviews = ''
        this.conceal = ''
        this.editFields = ''
        this.forms = {}
        this.pagination = {}
        this.box = 'hide'
        this.modal = 'hide'
        this.contents = []
        this.data = 0
        this.rowData = {}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    @action
    resetData = () =>{
        runInAction(()=>{
            this.data = 0
        })
    }

    /**
     * 初始化车系
     */
    @action
    initCarseries = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalogs/list`)
        if(res && res.status === 0){
            return
        }
        runInAction(() => {
            this.carseries = res
            this.loading = false
        })
    }

    /**
     * 取车系ID
     */
    @action
    getCarSysId = (value) =>{
        runInAction(()=>{
            this.carSysId = value;
        })
    }

    /**
     * 目录树
     */
    @action
    initDirectory = async (value) => {
        runInAction(() => {
            this.contents = []
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/list?carseriesId=${value}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.directory = [];
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.directory = res
            this.loading = false
        })
    }

    /**
     * 获取到目录树ID
     */
    @action
    stlcontent = (directoryId) =>{
        runInAction(() => {
            this.directoryId = directoryId.id
        })
    }

    /**
     * 显示内容
     */
    @action
    loadContents = async () => {
        runInAction(() => {
            this.loading = true
            this.contents = []
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/selectLevel?id=${this.directoryId}`)
        if (res.status && res.status === 0) {
            return
        }
        runInAction(() => {
            this.data = res.data
        })
        if(res.data > 2){
            const review = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog:approvalState/${this.directoryId}`)
            runInAction(() => {
                if(review === 0){
                    this.reviews = '注意：当前无内容状态,请先编辑内容'
                }else if(review === 1){
                    this.reviews = '注意：当前草稿状态，请先送审'
                }else if(review === 2){
                    this.reviews = '注意：当前待审状态'
                }else if(review === 3){
                    this.reviews = '注意：当前审批通过状态'
                }
            })
            const contents = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/content/searchOne?id=${this.directoryId}`)
            runInAction(() => {
                this.conceal = review
                this.contents = contents.length ? contents : [{
                        id: `${uuid()}`,
                        image: ' ',
                        defaultContent: '',
                        type: 1,
                        catalogId: this.directoryId
                    }]
                this.loading = false
            })} else {
            runInAction(() => {
                this.loading = false
            })
        }
    }

    /**
     *显示通过编辑框
     */
    @action
    showBox = (option) =>{
        runInAction(() => {
            this.editFields = ""
            this.box = 'show'
            this.option = option
        })
    }

    /**
     *关闭通过编辑框
     */
    @action
    closeBox = () =>{
        this.box = 'hide'
        this.modal = 'hide'
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            suggestion: {value: this.forms.suggestion},
        }
        return fields
    }
    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onEditFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            suggestion: fields.suggestion.value,
        }
        this.editFields = forms
    }

    /**
     * 保存审批意见
     * 审批通过
     * 审批驳回
     * 重置
     */
    @action
    operation = async (values) =>{
        runInAction(() => {
            this.loading = true
        })
        if(values){
            runInAction(()=>{
                this.editFields = values.suggestion
            })
        }
        //审批通过
        if(this.option === 2){
            const data = {
                "approvalOption": 1,
                "catalogId": this.directoryId,
                "suggestion":this.editFields
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/approval`, data);
            if (res.status && res.status === 0) {
                return
            }
            const res1 = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/updateApprovalState/`+this.directoryId+`/3`);
            if (res1.status && res1.status === 0) {
                return
            }
            runInAction (() =>{
                this.loading = false
                this.closeBox();
                message.success("审核通过！");
                this.loadContents();
            })
            return
        }else if(this.option === 1){
            const data = {
                "approvalOption": 2,
                "catalogId": this.directoryId,
                "suggestion": this.editFields
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/approval`, data);
            if (res.status && res.status === 0) {
                return
            }
            const res1 = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/updateApprovalState/`+this.directoryId+`/1`);
            if (res1.status && res1.status === 0) {
                return
            }
            runInAction (() =>{
                this.loading = false
                this.closeBox();
                message.success("审核驳回！");
                this.loadContents();
            })
            return
        }else {
            runInAction(() => {
                this.loading = true
            })
            const data = {
                "approvalOption": 3,
                "catalogId": this.catalogSelectId,
                "suggestion":this.editFields
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/approval`, data);
            if (res.status && res.status === 0) {
                return
            }
            const res1 = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/updateApprovalState/`+this.directoryId+`/1`);
            if (res1.status && res1.status === 0) {
                return
            }
            runInAction (() =>{
                this.loading = false
                this.closeBox();
                message.success('重置成功！');
                this.loadContents();
            })
        }
    }

    /**
     * 审批历史列表
     */
    @action
    initHistoryList = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        // 服务器page参数下标从0开始
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/approvals:search`, {
            page,
            catalogId: this.directoryId,
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content.map(item => {
                return {
                    id: item.id,
                    createTime: item.createTime,
                    approvedMan: item.approvedMan,
                    approver: item.approver,
                    approvalOption:item.approvalOption,
                    suggestion: item.suggestion,
                }
            })
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                results: res.size,
            }
            this.loading = false
            this.modal = 'show'
        })
    }

    /**
     * 初始化页面
     */
    @action emptyPage = () =>{
        runInAction(() => {
            this.contents = []
            this.directory = []
        })
    }
}
export default new ApprovalStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/EAtlas/EAtlasApproval/store.js